module.exports = __webpack_public_path__ + "static/media/2-1@2x.ed938354.png";